(function () {
  const STAR_SVG =
    '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.5 14.6 9l5.9.5-4.5 3.8 1.4 5.6L12 16.8 6.6 18.9l1.4-5.6-4.5-3.8 5.9-.5L12 3.5Z"/></svg>';

  const CART_SVG =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 10V6a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v4m-8 2h10l.9 11H8.1L9 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function cfg() {
    return window.ThemeProductCard || {};
  }

  function formatMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.Shopify?.money_format || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function buildStarsHtml(fillPercent = 100) {
    const star = `<span class="icon icon-stars__star" aria-hidden="true">${STAR_SVG}</span>`;
    const five = Array(5).fill(star).join('');
    return `<div class="icon-stars" style="--icon-stars-fill:${fillPercent}%"><span class="icon-stars__track">${five}</span><span class="icon-stars__fill">${five}</span></div>`;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /**
   * @param {object} product — Shopify product JSON
   * @param {{ floatingAdd?: boolean, wrapItem?: boolean }} [options]
   */
  function buildProductCard(product, options = {}) {
    const settings = cfg();
    const variant = product.variants?.[0];
    const price = variant?.price ?? product.price ?? 0;
    const compareAt = variant?.compare_at_price ?? 0;
    const onSale = compareAt > price;
    const percentOff = onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
    const floatingAdd = options.floatingAdd === true;
    const wrapItem = options.wrapItem !== false;

    const image = product.featured_image || product.images?.[0];
    const imageHtml = image
      ? `<img class="product-card__image" src="${image}" alt="${escapeHtml(product.title)}" loading="lazy" width="400" height="400">`
      : '<div class="demo-placeholder demo-placeholder--product"></div>';

    const badgePosition = settings.badgePosition || 'top-left';
    const badgeHtml =
      settings.showSaleBadge !== false && onSale && percentOff > 0
        ? `<span class="product-card__badge">${percentOff}% ${escapeHtml(settings.offLabel || 'off')}</span>`
        : '';

    let reviewCountHtml = '';
    if (settings.showReviewCount !== false) {
      const count =
        product.metafields?.reviews?.rating_count?.value ??
        product.metafields?.custom?.review_count?.value;
      if (count != null && Number(count) > 0) {
        reviewCountHtml = `<span class="product-card__review-count">(${Number(count)})</span>`;
      }
    }

    const reviewsHtml =
      settings.showReviews !== false
        ? `<div class="product-card__reviews">
            <div class="product-card__stars" role="img" aria-hidden="true">${buildStarsHtml(100)}</div>
            ${reviewCountHtml}
          </div>`
        : '';

    const compareHtml =
      settings.showComparePrice !== false && onSale && compareAt
        ? `<s class="price__compare">${formatMoney(compareAt)}</s>`
        : '';

    const priceHtml =
      settings.showPrice !== false
        ? `<div class="product-card__price price${onSale ? ' price--on-sale' : ''}">
            ${compareHtml}
            <span class="price__current">${formatMoney(price)}</span>
          </div>`
        : '';

    const metaHtml =
      reviewsHtml || priceHtml
        ? `<div class="product-card__meta">${reviewsHtml}${priceHtml}</div>`
        : '';

    const floatingHtml =
      floatingAdd && settings.showAddToCart !== false && variant?.id
        ? `<form action="/cart/add" method="post" class="product-card__floating-add-form" data-card-floating-add>
            <input type="hidden" name="id" value="${variant.id}">
            <button type="submit" class="product-card__floating-add" data-add-button aria-label="${escapeHtml(settings.addToCartLabel || 'Add to cart')}">
              <span class="icon" aria-hidden="true">${CART_SVG}</span>
            </button>
          </form>`
        : '';

    const formHtml =
      !floatingAdd && settings.showAddToCart !== false && variant?.id
        ? `<form action="/cart/add" method="post" enctype="multipart/form-data" class="product-card__form">
            <input type="hidden" name="id" value="${variant.id}">
            <button type="submit" class="button product-card__add" data-add-button>
              <span class="product-card__add-text">${escapeHtml(settings.addToCartLabel || 'Add to cart')}</span>
            </button>
          </form>`
        : '';

    const cardStyle = `--pc-star-size: ${settings.starSize || 18}px; --pc-star-color: ${settings.starColor || '#e6a817'}; --pc-price-size: ${settings.priceSize || 16}px; --pc-meta-color: ${settings.metaColor || 'var(--color-text)'}; --pc-badge-color: ${settings.badgeColor || '#c0392b'};`;

    const cardHtml = `
      <article class="card product-card product-card--badge-${badgePosition}${floatingAdd ? ' product-card--floating-add' : ''}" style="${cardStyle}">
        <div class="product-card__media-wrap">
          <a href="${product.url}" class="product-card__media">
            <span class="product-card__image-wrap">${imageHtml}</span>
            ${badgeHtml}
          </a>
          ${floatingHtml}
        </div>
        <div class="product-card__content">
          <h3 class="product-card__title"><a href="${product.url}">${escapeHtml(product.title)}</a></h3>
          ${metaHtml}
          ${formHtml}
        </div>
      </article>`;

    if (!wrapItem) return cardHtml;

    return `<div class="product-rows__item">${cardHtml}</div>`;
  }

  window.buildThemeProductCard = buildProductCard;
})();
